// material-ui
import { Box, Typography, Divider } from '@mui/material';
import { FC } from 'react';
import { Control, Controller, FieldError, useFormContext } from 'react-hook-form';

import { Colors } from '@/assets';
import { getErrorMessageForm } from '@/lib';
interface IProps {
    name: string;
    control?: Control;
    onChange?: (event: any) => void;
    placeholder?: string;
    msg?: FieldError;
    defaultValue?: string;
    label?: string;
    type?: 'text' | 'password' | 'area';
    icon?: string;
    rows?: number;
    sampleString?: string;
    noneResizable?: boolean;
    disabled?: boolean;
}

export const InputText: FC<IProps> = ({
    sampleString,
    msg,
    name,
    onChange,
    placeholder,
    defaultValue = '',
    label,
    type = 'text',
    icon,
    rows = 5,
    noneResizable,
    disabled
}) => {
    const {
        register,
        errors,
        formState: { touched, isSubmitted }
    } = useFormContext();

    const errorMessage = getErrorMessageForm({ name, errors, touched, isSubmitted });

    return (
        <Box sx={{ width: '100%' }}>
            {label && (
                <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                    {label}
                </Typography>
            )}
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: Colors.linkWater,
                    borderRadius: '8px',

                    boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                    backgroundColor: Colors.white,
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {sampleString && (
                    <>
                        <Typography variant="h6" sx={{ color: Colors.lynchBlue, padding: '1.2rem', fontWeight: 400 }}>
                            {sampleString}
                        </Typography>
                        <Divider orientation="vertical" flexItem />
                    </>
                )}
                {icon && <Typography className={icon} sx={{ fontSize: 18, color: Colors.lynchBlue, ml: 1.5 }}></Typography>}
                <Box
                    component={type === 'area' ? 'textarea' : 'input'}
                    ref={register}
                    disabled={disabled}
                    sx={{
                        padding: '1.2rem',
                        fontSize: '1.6rem',
                        border: 0,
                        borderRadius: '8px',
                        color: Colors.tangaroaBlue,
                        outline: 'none',
                        width: '100%',
                        fontFamily: 'inherit',
                        letterSpacing: 0.2,
                        '&:placeholder': {
                            color: Colors.lynchBlue
                        },
                        resize: noneResizable ? 'none' : 'vertical'
                    }}
                    name={name}
                    defaultValue={defaultValue}
                    autoComplete={name}
                    rows={rows}
                    type={type}
                    onChange={(e: any) => {
                        onChange && onChange(e);
                    }}
                    placeholder={placeholder}
                />
            </Box>
            {errorMessage && (
                <Typography variant="subtitle2" sx={{ mt: 0.5, color: Colors.bittersweetOrange }}>
                    {errorMessage}
                </Typography>
            )}
        </Box>
    );
};
